<div class="chips-container">
  <div
    *ngFor="let c of chips"
    [ngClass]="{ 'chips-group': isRadSurvey }"
  >
    <mat-chip
      class="mat-chip {{ c.cssClass }}-background chip-item"
      [matTooltip]="c.status"
      [matTooltipClass]="c.cssClass + '-background small'"
      (click)="openDocument(c.serialNo)"
      [ngClass]="{ shadow: shadow, 'static-chip': staticDisplay }"
    >
      <span class="btn-link white nowrap">{{ c.serialNo }}</span>
    </mat-chip>

    <!-- This section is to display Checklists on each Form -->
    <div *ngIf="isRadSurvey" class="checklist-chips">
      <mat-icon class="checklist-arrow">start</mat-icon>
      <div
        *ngFor="let r of c.documentChips"
        class="checklist-chip-item"
      >
        <mat-chip
          class="mat-chip chip-item {{ r.cssClass }}-background"
          [ngClass]="{ 'static-chip': staticDisplay }"
          [matTooltip]="r.status"
          [matTooltipClass]="r.cssClass + '-background small'"
          (click)="openDocument(r.serialNo)"
        >
          <span class="btn-link white nowrap">{{ r.serialNo }}</span>
        </mat-chip>
      </div>
      <span
        *ngIf="!c.documentChips?.length"
        class="no-checklists"
      >
        <mat-icon class="yellow small">warning</mat-icon>No Associated Rad Survey Found
      </span>
    </div>
  </div>
</div>
